import { ELSModalServiceType } from 'models/els';

export interface BarcodeDetailsState {
  patient: BarcodePatient;
  medications: MedicationItem[];
}

export interface DropDownItem {
  id: string;
  name: string;
  value: string;
}

export interface BarcodeModalContentProps {
  assignmentId?: number;
  simulationEhrId?: string;
  userId?: number;
  modalService: ELSModalServiceType;
  modalId: string;
}

export interface MedicationItem {
  id: string;
  medicationName: string;
  dose: string;
  form?: string;
  barcodeValue: string;
  selected: boolean;
  isDistractor?: boolean;
}

export interface BarcodePatient {
  name: string;
  mrn: string;
  age: string;
  patientId: string;
  allergies: string;
  dateOfBirth: string;
}

export const formatMedicationName = (item: Pick<MedicationItem, 'medicationName' | 'form'>) => (
  item.form ? `${item.medicationName} - ${item.form}` : item.medicationName
);
